const l=l=>null==l;export{l as isNullableValue};
